
import React from "react";
import { SidebarFooter as Footer } from "@/components/ui/sidebar";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getRoleName } from "@/utils/roleUtils";
import { useOnboardingTour } from "@/contexts/OnboardingTourContext";
import { useCommunityScope } from "@/contexts/CommunityScopeContext";

export const SidebarFooter: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const { activeMembershipProfile, isGlobalAdmin } = useCommunityScope();
  const { start } = useOnboardingTour();
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);
  const effectiveRole = isGlobalAdmin ? currentUser?.role : activeMembershipProfile?.role;

  const handleLogout = async () => {
    if (isLoggingOut) {
      return;
    }

    setIsLoggingOut(true);
    try {
      await logout();
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <Footer className="border-t border-sidebar-border bg-sidebar p-4">
      <div className="flex flex-col gap-3">
        <div className="border border-sidebar-border bg-sidebar-accent/40 p-3 shadow-[0_-18px_48px_-44px_rgba(255,255,255,0.45)]">
          <Link
            to="/app/profile"
            className="flex items-center gap-3 transition-colors hover:text-sidebar-ring"
          >
            <Avatar className="border border-sidebar-ring/40 bg-sidebar-accent">
              <AvatarImage src={currentUser?.avatar} />
              <AvatarFallback>{currentUser?.name.charAt(0)}</AvatarFallback>
            </Avatar>
            <div className="min-w-0 text-sm">
              <p className="truncate font-medium text-sidebar-foreground">{currentUser?.name}</p>
              <p className="text-xs text-sidebar-foreground/80">
                {effectiveRole ? getRoleName(effectiveRole) : ''}
              </p>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="border border-sidebar-border text-sidebar-foreground hover:border-sidebar-ring/30 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
            disabled={isLoggingOut}
          >
            Salir
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={start}
            className="justify-center border border-sidebar-ring/30 bg-sidebar-ring/10 text-sidebar-foreground hover:bg-sidebar-ring/20"
            data-onboarding="tour-reopen"
          >
            Ver tour
          </Button>
        </div>
      </div>
    </Footer>
  );
};
